import { h, VNode, toChildArray, FunctionComponent, ComponentChildren, Fragment } from "preact"; /** @jsx h */
import { clsx } from 'clsx';


import { IItemProps } from "./Item";


export type IStandardProps = {
    children?: Array<VNode<IItemProps>> | VNode<IItemProps>;
};

export const Standard = (props: IStandardProps) => {
    return (
        <Fragment>
            {
                toChildArray(
                    props.children
                ).filter(
                    (child: any) => child?.type?.name == "Item" || child?.type?.name == "List_Item"
                ).map((child: any) => {
                    return {
                        ...child,
                        props: {
                            ...child.props,
                            mode: 'standard'
                        }
                    }
                })
            }
        </Fragment>
        
        
    );
}